import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics } from '@/hooks/useAnalytics.js';
import useLoadUser from '@/hooks/useLoadUser.js';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';

const ConnectivityStateHandler = () => {
  const { isLoaded } = useLoadUser();
  const { trackEvent } = useAnalytics();
  const companyId = useSelector(selectors.companyId);
  const companyChannel = useSelector((state) => selectors.user(state)?.jwt?.companyChannel);
  const userChannel = useSelector((state) => selectors.user(state)?.jwt?.userChannel);
  const websocketState = useSelector(memoizeSelector('websocket', (state) => selectors.websocket(state)));
  const isWelcomePage = useSelector((state) => selectors.pathname(state) === '/workflows');

  useEffect(() => {
    if (isLoaded) {
      const isWebsocketDisconnected = websocketState?.connectionStatus === 'Disconnected';
      const isMissingUserChannel = !userChannel;
      const isMissingCompanyChannel = !companyChannel;
      // const message = `There is an issue with MindCloud's realtime communication, you may still use the app, but there might be unexpected behavior. Please contact MindCloud support.`;
      if (isWebsocketDisconnected || isMissingUserChannel || isMissingCompanyChannel) {
        if (!isWelcomePage && companyId) {
          trackEvent('connectivity-issue', { isWebsocketDisconnected, isMissingUserChannel, isMissingCompanyChannel, companyId });
          // setErrorSplashScreen(true, { message, actions: ['CLOSE', 'RELOAD'], id: 'socket' });
        }
      }
    }
  }, [websocketState.connectionStatus, websocketState?.missingChannels?.userChannel, websocketState?.missingChannels?.companyChannel, isWelcomePage, companyId]);

  return null;
};

export default ConnectivityStateHandler;
